import { useEffect, useState } from "react";
import styles from "./NavSearch.module.scss";
import { BiSearch } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FILTER_BY_SEARCH } from "../../redux/features/post/filterSlice";
import { getPosts } from "../../redux/features/post/postSlice";

const NavSearch = () => {
  const { posts } = useSelector((state) => state.post);

  const [search, setSearch] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(FILTER_BY_SEARCH({ posts, search }));
  }, [dispatch, posts, search]);

  const navigate = useNavigate();

  return (
    <div className={styles.contain}>
      <div className={styles.search} onClick={() => navigate("/search")}>
        <BiSearch size={18} className={styles.icon} />
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    </div>
  );
};

export default NavSearch;
